import { STORAGE_KEYS } from "../constants/storageKeys";
import { setSessionStorageItem } from "../utils/utils";
import { apiClient, getCurrentAccessToken } from "./ApiClient";
import _ConfigService from "./ConfigService";

const getUserContextToken = async (): Promise<string> => {
  // Get the current access token
  const authToken = await getCurrentAccessToken();

  if (!authToken) {
    throw new Error("missing access token for custom authorization");
  }

  const { data } = await apiClient.get("/auth/custom-token", {
    headers: {
      "custom-authorization": authToken,
    },
  });
  setSessionStorageItem(STORAGE_KEYS.UserContextToken, data.data.custom_token);
  return data.data.custom_token;
};

const UserContextService = {
  getUserContextToken,
};

export default UserContextService;
